import {Routes} from '@angular/router';

export const categoryRecommendationRoutes: Routes = [
  {
    path: 'categoryRecommendation',
    loadComponent: () => import('./category-recommendation.component').then(m => m.CategoryRecommendationComponent),
    data: { title: '品类橱窗' },
  },
];
